<template>
    <v-container fluid>
        <v-row justify="space-around">
            <h2 style="color:indianred; text-align: center; font-size: 1.5rem;">
                Ha surgido algún problema con su inscripción
            </h2>
        </v-row>
        <v-row justify="space-around">
            <v-row style="text-align: center">
                <v-col cols="4" xs="12" md="4" sm="6">
                    <v-btn
                            color="success"
                            :to="{name:'roscon'}"
                    >
                        Inscribirse en 10K
                    </v-btn>
                </v-col>
                <v-col cols="4">
                    <v-btn
                            color="success"
                            :to="{name:'corta'}"
                    >
                        Inscribirse en 7K
                    </v-btn>
                </v-col>
                <v-col cols="4">
                    <v-btn
                            color="success"
                            :to="{name:'infantil'}"
                    >
                        Inscribirse en la carrera infantil
                    </v-btn>
                </v-col>
            </v-row>

        </v-row>
        <v-row justify="space-around">
            <h2 style="color:black; text-align: center; font-size: 1.5rem;">
                Acceda a los listados de inscritos
            </h2>
        </v-row>
        <v-card>
            <v-row style="text-align: center">
                <v-col cols="4" xs="12" md="4" sm="6">
                    <v-btn
                            color="info"
                            :to="{name:'listado'}"
                    >
                        Listado inscritos 10K
                    </v-btn>
                </v-col>
                <v-col cols="4">
                    <v-btn
                            color="info"
                            :to="{name:'listadoCorta'}"
                    >
                        Listado inscritos 7K
                    </v-btn>
                </v-col>
                <v-col cols="4">
                    <v-btn
                            color="info"
                            :to="{name:'listadoInfantil'}"
                    >
                        Listado inscritos infantil
                    </v-btn>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row style="text-align: center">
                <v-col cols="12" xs="12" >
                    <v-btn
                            color="orange"
                            href="http://osandarines.com/secciones/atletismo/10kroscon/">
                        Información sobre XI CARRERA POPULAR 10K DEL ROSCÓN 2020
                    </v-btn>
                </v-col>
                <v-col cols="12" xs="12" mb="6">
                    <v-btn
                            color="info"
                            href="http://reservasprames.com/roscon10k/rectificacion.php"
                            target="_blank"
                    >
                        Quiero cambiar los datos de mi inscripción
                    </v-btn>
                </v-col>
            </v-row>
            <br>

        </v-card>
    </v-container>
</template>

<script>
    export default {
        name: "Fallida"
    }
</script>

<style scoped>

</style>